import React from 'react'

const EngagementRings = () => {
  return (
    <iframe scrolling="yes" width="100%" height="2300px" frameborder="0" sandbox="allow-scripts allow-forms allow-same-origin" src="https://morgantaylor-frame-categoryembed.jewelershowcase.com/browse/wedding-and-engagement"></iframe>
  )
}

export default EngagementRings
